<template>
  <div>
    <div class="ModelSelect">
    Current Model:
      <el-select v-model="modelID" placeholder="Place Select">
                  <el-option
                    v-for="item in models"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                  </el-option>
                </el-select><br>
                High Quality means the difference between Host Image and Container Image as well as  Secret Image and Extracted Image will be super small, but it is vulnerable when container image under distortion. <br>
                High Roubustness means the difference will be relatively high, but it is robust to some distortions.
              </div>
    <div class="result-container">
      <transition 
      appear
      name="animate__animated animate__bounce"
      enter-active-class="animate__rubberBand"
      >
      </transition>
      <div>
        <el-row type="flex" justify="center">
          <el-col :span="11">
            <div class="grid-content bg-purple">
              <div v-show="img1">Image 1: {{ img1size1 }}x{{ img1size2 }}</div>
              <div v-show="img1"><img class="img" :src="img1" /> <br>
                <el-select v-model="hostid" placeholder="Place Select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </div>
              </div>
            </el-col>
          <el-col :span="11">
            <div class="grid-content bg-purple-light">
              <div v-show="img2">Image 2: {{ img2size1 }}x{{ img2size2 }}</div>
              <div v-show="img2"><img class="img" :src="img2" /> 
                <br>             
                <el-select v-model="hostid" placeholder="Place Select">
                  <el-option
                    v-for="item in optionsinv"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
        </el-row>
        <br>
        <el-button v-show="img1" type="primary" @click="processhide" :loading="isProcessing">Hide</el-button>
        <el-button v-show="img1" type="primary" @click="processextract" :loading="isProcessing">Extract</el-button>

        <br>
        <div v-show="yimg"><img class="img" :src="yimg" /> <br> Result </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'animate.css'
import { inject } from "vue";
import axios from "axios";
export default {
  name: "Display",
  components: {},
  data() {
      return {
        options: [{
          value: 0,
          label: 'Host Image'
        }, {
          value: 1,
          label: 'Secret Image'
        },{
          value: 'Ignore',
          label: 'Container Image'
        }, ],
        optionsinv: [{
          value: 1,
          label: 'Host Image'
        }, {
          value: 0,
          label: 'Secret Image'
        },
        {
          value: 'Ignore ', //空格用于实现unprocess不出现在选项中
          label: 'Container Image'
        },],
        hostid:'Ignore',
        yimg: false,
        models:[
          {
            value:0,
            label:'High Quality'
          },
          {
            value:1,
            label:'High Robustness'
          },],
        modelID:0,
        isProcessing:false,
      }
    },
  methods:{ 
    processhide() {
      console.log(this.modelID)
      if ( this.hostid == 'Ignore' || this.hostid == 'Ignore ' || this.img2==false){
        this.$alert('Hiding requires one Host Image and one Secret Image, please check!!', 'Wrong!', {
          confirmButtonText: 'OK',
        });
      } else {
        //const timg2 = new Image();
        if (this.img1size1 == this.img2size1 && this.img1size2 == this.img2size2){
          console.log('hiding')
          this.upload(this.hostid, this.modelID)
        } else {
          this.$alert('The resolution of Host Image and Secret Image is not same, Secret Image will be resized according to the Host Image.', 'Warning!', {
          confirmButtonText: 'OK',
        })
        this.upload(this.hostid, this.modelID)
        }
    }
      
    },
    processextract() {
      if ( this.hostid == 0 || this.hostid == 1){
        this.$alert('Extraction requires one Container Image, please choose a Container Image!!', 'Wrong!', {
          confirmButtonText: 'OK',
        });
      } else {
        this.upload(this.hostid, this.modelID)
      }
    },
    upload(hostid, modelID) {
      console.log('uploading');
      this.isProcessing = true
      let config = { "Content-Type": "application/json; charset=utf-8",  responseType: 'blob'  };
      axios
        .post(
          "http://yanghang.site/hide/upload",
          { img1: this.img1, img2: this.img2, hostid: hostid, modelID: modelID },
          config
        )
        .then(response => { 
          // 将blob对象转换为一个动态的url，用于显示图片
          this.yimg = URL.createObjectURL(response.data)
          this.isProcessing = false
        }).catch(error => { // 处理错误 
            console.error(error)
            this.isProcessing = false
           })
      console.log('upload done')
      
    },
    
  },
  setup() {
    const showResult = inject("showResult");
    const img1 = inject("img1");
    const img2 = inject("img2");
    const img1size1 = inject('img1size1')
    const img1size2 = inject('img1size2')
    const img2size1 = inject('img2size1')
    const img2size2 = inject('img2size2')
    console.log(img1size1)
    return { showResult, img1, img2, img1size1, img1size2, img2size1, img2size2};
  },
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.img{
  max-width: 95%; /* make the image fit the container width */
  height: auto; /* preserve the image aspect ratio */
}

.ModelSelect{
  margin-left: 10%;
  margin-right: 10%;
}

</style>
